<!-- QRの読み取りで不正な文字列だった場合などのダイアログ fnc毎に表示するエラータイトルは変わる -->
<template>
  <ItemDialog ref="QRFail" imageType="alert">
    <template v-slot:content-area>
      <p>
        {{ failTitle }}
      </p>
    </template>

    <template v-slot:button-area>
      <ItemButton
        label="戻る"
        actionType="btn-primary"
        @clicked="handleClick()"
      />
    </template>
  </ItemDialog>
</template>

<script>
export default {
  name: "DialogQRFail",
  props: {
    failTitle: {
      type: String,
    },
  },
  methods: {
    async openDialog() {
      this.$refs.QRFail.open();
    },
    async closeDialog() {
      this.$refs.QRFail.close();
    },
    handleClick() {
      this.closeDialog();
      this.$emit("clicked");
    },
  },
};
</script>
